import { MAILTO } from "@/lib/site";

export default function TopStrip() {
  return (
    <div className="top-strip" data-testid="top-strip">
      <div className="wrap inner">
        <div className="msg">
          <span className="leaf" aria-hidden="true">◆</span>
          <span>Bulk ingredients · Product specifications · Samples · Buyer documentation available on request</span>
        </div>
        <a
          className="connect-pill"
          href={MAILTO}
          data-testid="top-strip-connect"
        >
          Connect →
        </a>
      </div>
    </div>
  );
}
